import { useCallback, useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import createLead from '../lib/client/create-lead';
import { Lead } from '../types/lead';
import { trackLeadData } from './google-tag-manager';
import { useLeadCaptured } from './lead-capture-form';

export const useLeadCapture = (args?: { persist?: boolean }) => {
  const { persist = true } = args ?? {};

  const [data, setData] = useSessionStorage<Lead | undefined>('lead-data', undefined);
  const [, setLeadCaptured] = useLeadCaptured();

  const submit = useCallback<typeof createLead>((lead) => {
    trackLeadData({
      email: lead.details.email,
      phone: lead.details.mobile,
      firstName: lead.details.firstName,
      lastName: lead.details.lastName,
    });

    setData(lead);

    return createLead(lead).then((result) => {
      if (persist) {
        setLeadCaptured(true);
      }

      return result;
    });
  }, [persist, setData, setLeadCaptured]);

  return useMemo(() => ({
    submit,
    data,
  }), [data, submit]);
};
